const MessagesPagePermissions = {
    loggedIn: true,
    userMode: "RED",
    accessRule: [
        { role: "ADMIN" },
        { role: "MESSENGER" }
    ],
    deinedRule: { role: "G_ADMIN" }
}

const CompanyManagePagePermissions = {
    loggedIn: true,
    accessRule: { role: "G_ADMIN" }

}

const OrganizationStructurePagePermissions = {
    loggedIn: true,
    deinedRule: { role: "G_ADMIN" }
}

const DocumentsPagePermissions = {
    loggedIn: true,
    userMode: "RED",
    deinedRule: { role: "G_ADMIN" }
}

const DocumentsUserModePagePermissions = {
    loggedIn: true,
    userMode: "BLUE",
    deinedRule: { role: "G_ADMIN" }
}

const EditCompanyDataPagePermissions = {
    loggedIn: true,
    userMode: "RED",
}

const JobConnectedPagePermissions = {
    loggedIn: true,
    deinedRule: { role: "G_ADMIN" }
}

const DocConnectedPagePermissions = {
    loggedIn: true,
    deinedRule: { role: "G_ADMIN" }
}

const UsersPagePermissions = {
    loggedIn: true,
    accessRule: [
        { role: "G_ADMIN" },
        { role: "ADMIN" },
        { role: "USER_MGR" }
    ],
}

const AuditPagePermissions = {
    loggedIn: true,
    userMode: "RED",
    deinedRule: { role: "G_ADMIN" }
}

const WorkflowinfoPagePermissions = {
    loggedIn: true,
    deinedRule: { role: "G_ADMIN" }
}
const PluginManagementPagePermissions = {
    loggedIn: true,
    accessRule: { role: "ADMIN" }
}
const PasswordManagmentPagePermissions = {
    loggedIn: true,
    userMode: "RED",
    accessRule: {
        role: "CMP_MAIN",
        and: [
            { 
                role: "ADMIN",
                and: [
                    { role: "PASSWD_MGR" }
                ]
            }
        ]
    }
    
}
const PluginProviderPermissions = {
    loggedIn: true,
    deinedRule: { role: "G_ADMIN" }
}

const FirstSetupPagePermissions = {
    firstSetup: true,
}

const LoginPagePermissions = {
    loggedIn: false,
    
}


export {
    MessagesPagePermissions,
    CompanyManagePagePermissions,
    OrganizationStructurePagePermissions,
    DocumentsPagePermissions,
    DocumentsUserModePagePermissions,
    EditCompanyDataPagePermissions,
    JobConnectedPagePermissions,
    DocConnectedPagePermissions,
    UsersPagePermissions,
    AuditPagePermissions,
    WorkflowinfoPagePermissions,
    PluginManagementPagePermissions,
    PasswordManagmentPagePermissions,
    PluginProviderPermissions,
    FirstSetupPagePermissions,
    LoginPagePermissions
}